export const postIframeMessage = <T>(name: string, payload?: T) => {
  window?.parent?.postMessage(
    {
      type: name,
      payload
    },
    '*'
  );
};
